import jQuery from 'jquery';
import mixitup from 'mixitup';

jQuery(function($) {
  if ($('.production__list').length > 0) {
    let mixer = mixitup('.production__list');
  }
});
